<script>
import { mapGetters, mapState } from 'vuex'

export default {
  data () {
    return {
      price: null,
      loading: false,
      pricePerCableMeter: null,
      apiUrl: process.env.VUE_APP_PRICING_API_URL,
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
    }
    
  },
  props: {
    cableLength: {
      type: Number,
      default: 1.0
    }
  },
  methods: {
    async fetchPrice (partsList) { 

      //console.log('fetchPriced', partsList) // eslint-disable-line no-console
      if (!this.loggedIn) return
      if (!this.showPrice) return
      
      this.loading = true

      const productGroupMap = {
        'patch-cord': 'VA02',
        'trunk': 'VB10',
        'breakout': 'VB02',
        'fanout': 'VB10'
      }

      let productGroup = productGroupMap[this.$route.name]

      if (this.isDuplexBreakoutCable()) {
        if (this.$store.state.getsDataCenterProducts) {
          productGroup = 'DA03'
        } else {
          productGroup = 'VA04'
        }
      }


      // ToDo: refactor to prop
      const baseLength = this.$route.name === 'patch-cord'
        ? 1
        : this.$store.getters.minCableLengthTrunk


      this.$store.state.pricingRequestData = { 
        baseLength,
        cableLength: this.cableLength,
        partsList: partsList.join('|'),
        productGroup,
        surcharge: this.$store.state.surcharge
      }

      // with axios
      try {
        let response = await this.axios.post(
          this.apiUrl,
          JSON.stringify({
            partsList: partsList.join('|'),
            productGroup: productGroup,
            cableLength: this.cableLength,
            // ToDo: refactor to prop
            surcharge: this.$store.state.surcharge,
            baseLength
          }),
          {
            headers: { 'Content-Type': 'application/json' }
          }
        )
        this.price = response.data.price
        this.loading = false
        this.pricePerCableMeter = response.data.meterMin * ((100 + this.$store.state.surcharge) / 100)

        try {
          this.$store.state.price = this.price
          this.$store.state.listPrice = this.price / ((100 - parseFloat(this.$store.state.discount)) / 100)
          this.$store.state.cablePricePerMeter = response.data.meterMin
          this.$store.state.baseCablePrice = response.data.baseValue
          this.$store.state.minPrice = response.data.minPrice
        } catch (e) {
          // eslint-disable-next-line
        }


      } catch (err) {
        this.$rollbar.error('can not fetch price', { partsList, from: this.apiUrl, err })
        this.loading = false
      }
    },
    isDuplexBreakoutCable () {
      if (!this.$store.state.filters.cables.cableType) return false
      if (!this.$store.state.filters.cables.fiberCount) return false

      if (this.$store.state.filters.cables.fiberCount === '2x1' && this.$store.state.filters.cables.cableType === 'I-V(ZN)HH')
        return true

      return false
    }
  },
  computed: {
    ...mapGetters([
      'linearizedPartsList',
      'selectedValue'
    ]),
    ...mapState([
      'discount',
      'loggedIn',
      'showPrice'
    ]),
    fiberCount () {
      return this.selectedValue('cables', 'fiberCount')
    }
  },
  render () {
    return this.$scopedSlots.default({
      price: this.price, // ((100 - this.discount) * this.price) / 100,
      listPrice: this.price * ((100 + parseFloat(this.$store.state.discount)) / 100),
      loading: this.loading,
      cablePricePerMeter: this.pricePerCableMeter
    })
  },
  async mounted () {
    if (this.linearizedPartsList.length > 0)
      await this.fetchPrice(this.linearizedPartsList)
  },
  watch: {
    async cableLength () {
      if (this.linearizedPartsList.length > 0) {
        await this.fetchPrice(this.linearizedPartsList)
      }
    },
    async linearizedPartsList () {
      if (this.linearizedPartsList.length > 0) {
        await this.fetchPrice(this.linearizedPartsList)
      }
    }

  }
}
</script>